<template>
  <div style="text-align: right;padding-right: 20px;">
    <el-button type="primary" @click="btnAddAupplier" tkey="添加產品">{{i18n.tkey("lang_select")}}{{i18n.tkey("lang_exhibited_products")}}</el-button>
  </div>
    <div v-loading="loading">
        <div v-show="viewPart === 'list'">
            <HallProductList
                :list="dataList"
                :type="type"
                @del-success="delCallback"
                @save-success="saveCallback"
                @clickEdit="goEdit"
            />

            <PaginationComponent
                :pageObj="pageObj"
                @goPage="clickPage"
                v-if="dataList.length > 0 || pageNum > 1"
            />
        </div>

        <div>
            <el-dialog
                v-model="openEditVisible"
                :title="i18n.tkey('lang_modify')"
                :width="myUtil.isMobile() ? '90%' : '600px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
            >
                <hallProudtInfoEditor
                    v-if="editRecord != null"
                    :record="editRecord"
                    :companycode="companycode"
                    @save-complete="savePositionCallback"
                />
            </el-dialog>
        </div>
      <div>
        <el-dialog
            v-model="addsupplierVisible"
            :title="i18n.tkey('lang_select')+i18n.tkey('lang_exhibited_products')"
            :width="myUtil.isMobile() ? '90%' : '600px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
          <div >
            <div style="padding-bottom: 20px">
              <span v-if="util.isEmpty(companycode)" >{{i18n.tkey("lang_join_hall_company")}}</span>

              <el-select
                  v-model="mdcompanyCode"
                  :placeholder="i18n.tkey('lang_join_hall_company')"
                  size="large"
                  style=""
                  @change="changeCompany"
                  v-if="util.isEmpty(companycode)"
              >
                <el-option
                    v-for="item in companyList"
                    :key="item.countrycode"
                    :label="item.company.companyname"
                    :value="item.companycode"
                />
              </el-select>


              <el-button type="primary" @click="btnAddAllProudt(v)" tkey="添加全部">{{i18n.tkey("lang_add")}}{{i18n.tkey("lang_all")}}</el-button>
            </div>

            <el-row v-for="(v, i) in hallALLmaterialList" :key="i + new Date().getTime()" style="border-bottom: 1px #d9d9d9 solid;" >
              <el-col :span="6"  >

                <img :src="myUtil.generateProductImg(v)" style="width: 90%" onerror="this.error = null">
              </el-col>
              <el-col :span="18"  >
                <el-row style="padding: 8px;">
                  <el-col :span="24" style="text-align: left">
                    <span tkey="產品id">id : {{v.productid}}</span>
                  </el-col>

                  <el-col :span="24"  style="text-align: left">
                    <span tkey="產品名稱">{{i18n.tkey("lang_product_name")}} : {{v.productname}}</span>
                  </el-col>
                  <el-col :span="24"  style="text-align: left">
                    <span tkey="公司名稱">{{i18n.tkey("lang_company_name")}} : {{v.companyname}}</span>
                  </el-col>

                  <el-col :span="24"  style="text-align: left">
                    <span tkey="產品單位">{{i18n.tkey("lang_product_unit")}} : {{v.unit}}</span>
                  </el-col>

                  <el-col :span="24"  style="text-align: left">
                    <span tkey="點擊數量">{{i18n.tkey("lang_click")}}{{i18n.tkey("lang_qty")}} : {{v.raddinfo3}}</span>
                  </el-col>
                  <el-col :span="18" style="text-align: left">
                    <span tkey="產品價格">{{i18n.tkey("lang_price_text")}} : {{v.cost}}</span>
                  </el-col>
                  <el-col :span="6"  style="text-align: right">
                    <el-button type="primary" @click="btnAddProudt(v)" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="hallALLmaterialList.length === 0">

            </el-empty>
          </div>

        </el-dialog>
      </div>


    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, toRef} from "vue";
import myUtil from "@/util/util";
import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
import util from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import HallProductList from "@/components/shopopee/hallManager/hallProductList.vue";
import record16Api from "@/request/record16Api";
import materialApi from "@/request/materialApi";
import HallProudtInfoEditor from "@/components/shopopee/hall/hallProudtInfoEditor.vue";
import record15Api from "@/request/record15Api";
import {countryList} from "@/util/countrycode";
const publicPath = process.env.BASE_URL

const props = defineProps(["hallObj", "type","companycode"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const loading = ref(false)
const viewPart = ref("list")
const openEditVisible = ref(false)

const pageNum = ref(1)
const pageSize = ref(100)
const pageObj = ref({})
const dataList = ref([])
const editRecord = ref(null)

const queryType = ref(0)
const addsupplierVisible = ref(false)
const keyword =ref("")
const hallALLmaterialList = ref([])
const companyList = ref([])
const mdcompanyCode=ref(null)
const mcompanyCode=ref(null)


// var layerNum = 1
// var costsNum = 1
function getHallRecord15ByPage(){
    loading.value = true

    const request = record15Api.getRecord15ListandCompanyByPage
    const params = request.getParams()

    params.recordno = null
    params.updatedid = props.hallObj.id
    params.pageNum = 1
    params.pageSize =1000

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            const obj = res.detail
          companyList.value = obj.list

        }else{
            myUtil.alertError(res.msg)
        }
    })
}

function queryMaterialRecord15ModelByPage(){
  const request = materialApi.queryMaterialRecord15ModelByPage
  const params = request.getParams()
  params.updatedid = props.hallObj.id
  params.bcatacode2 = ""
  params.productname = keyword.value
  if(util.isNotEmpty(props.companycode)){
    params.companycode = props.companycode
  }else  if(util.isNotEmpty(mcompanyCode.value)){
    params.companycode = mcompanyCode.value
  }
  params.pageNum = 1
  params.pageSize = 1000


  request.send(params, (res) => {
      if (null != res && res.code === 200){
        // materialList.value = detail.detail.list
        hallALLmaterialList.value = hallALLmaterialList.value.concat(res.detail.list)

      }else{
        hallALLmaterialList.value = []

      }
  })

}


function getHallRecord16ByPage(){
  loading.value = true

  const request = materialApi.queryMaterialRecord16ModelByPage
  const params = request.getParams()
  params.updatedid = props.hallObj.id
  params.pageNum = pageNum.value
  params.pageSize = pageSize.value
  if(util.isNotEmpty(props.companycode)){
    params.companycode = props.companycode
  }

  request.send(params, (res) => {
    loading.value = false
    if (res.code == 200){
      const obj = res.detail
      pageObj.value = obj
      dataList.value = obj.list

    }else{
      myUtil.alertError(res.msg)
    }
  })
}
function btnAddAupplier(){
  addsupplierVisible.value = true
  hallALLmaterialList.value = []
  queryMaterialRecord15ModelByPage()
}
function clickPage(num){
    pageNum.value = num

    getHallRecord16ByPage()
}


function saveCallback(){
  getHallRecord16ByPage()
}

function btnAddAllProudt(){

  loading.value = true
  for (let i = 0; i < hallALLmaterialList.value.length; i++) {

  const request = record16Api.insertAdditionalrecord16
  const params = request.getParams()
  params.addinfo1 = hallALLmaterialList.value[i].id
  params.recordno = hallALLmaterialList.value[i].productid
  params.addinfo2 = hallALLmaterialList.value[i].cost+''
  params.companycode = hallALLmaterialList.value[i].companycode
  params. updatedid = props.hallObj.id
  params.historydatetime = util.formatDate(new Date(), 'yyyy/MM/dd hh:mm:ss')

    request.send(params, (res) => {

      if (res.code == 200){
        loading.value = false
      if(i == (hallALLmaterialList.value.length-1)){
        myUtil.alertSuccess(i18n.tkey("lang_add_success"))
        getHallRecord16ByPage()

      }

      }else{
        loading.value = false
        myUtil.alertError(res.msg)
      }
    })

  }
}

function delCallback(){
    if (dataList.value.length === 1 && pageNum.value > 1){
        pageNum.value -= 1
    }
    getHallRecord16ByPage()
}

function goEdit(obj){
    editRecord.value = obj
    openEditVisible.value = true
}
function changeCompany(value){
  mcompanyCode.value = value
  hallALLmaterialList.value = []
  queryMaterialRecord15ModelByPage()
}

function savePositionCallback(){
    openEditVisible.value = false
  setTimeout(function (){
    editRecord.value = null
  },200)
    getHallRecord16ByPage()
}

function btnAddProudt(proudt){
  loading.value = true
  const request = record16Api.insertAdditionalrecord16
  const params = request.getParams()
  params.addinfo1 = proudt.id
  params.recordno = proudt.productid
  params.addinfo2 = proudt.cost+''
  params.companycode = proudt.companycode
  params. updatedid = props.hallObj.id
  params.historydatetime = util.formatDate(new Date(), 'yyyy/MM/dd hh:mm:ss')

  request.send(params, (res) => {
    loading.value = false
    if (res.code == 200){

      myUtil.alertSuccess(i18n.tkey("lang_add_success"))

      getHallRecord16ByPage()

    }else{
      myUtil.alertError(res.msg)
    }
  })

}


onBeforeMount(() => {
    if (null != props.type){
        queryType.value = props.type
    }

  getHallRecord16ByPage()
  getHallRecord15ByPage()
})

</script>

<style scoped>

</style>